// ─── Collage Intent Rules ─────────────────────────────────────
// Semantic layer for collage elements. Each element declares its
// role, importance, behavior, and mobile strategy. The renderer
// and editor use these to make smarter decisions.

// ─── Helpers ──────────────────────────────────────────────────

export function shouldHideOnMobile(element) {
  return element.intent?.mobileBehavior === 'hide';
}

export function getAnimationOrder(element) {
  return element.intent?.animationPriority ?? 999;
}

export function isDecorativeElement(element) {
  return (
    element.intent?.role === 'decorative' ||
    element.intent?.behavior === 'decorative'
  );
}

export function shouldProtectFromOverlap(element) {
  return (
    element.intent?.importance === 'high' ||
    element.intent?.overlapPolicy === 'none'
  );
}

// ─── Motion Preset Mapping ────────────────────────────────────

export function getMotionPreset(element) {
  const intent = element.intent;
  if (!intent) return 'stagger';
  if (intent.role === 'decorative') return 'drift';
  if (intent.importance === 'high') return 'reveal';
  if (intent.role === 'image') return 'fade';
  return 'stagger';
}

// ─── Editor Labels ────────────────────────────────────────────

const ROLE_LABELS = {
  primaryHeadline: 'Primary Headline',
  secondaryHeadline: 'Secondary Headline',
  bodyText: 'Body Text',
  metaText: 'Meta Text',
  image: 'Image',
  decorative: 'Decorative',
  cta: 'Call to Action',
};

export function getElementEditorLabel(element) {
  if (element.intent?.role) {
    return ROLE_LABELS[element.intent.role] || element.intent.role;
  }
  // Fallback: humanize the ID
  return element.id.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

// ─── Renderable Filter + Sort ─────────────────────────────────

export function getRenderableElements(elements, isMobile) {
  const visible = elements.filter(el => {
    if (!isMobile) return true;
    return !shouldHideOnMobile(el);
  });

  return [...visible].sort((a, b) => {
    const zA = a.layout?.desktop?.z ?? 1;
    const zB = b.layout?.desktop?.z ?? 1;
    if (zA !== zB) return zA - zB;
    return getAnimationOrder(a) - getAnimationOrder(b);
  });
}
